module.exports = __webpack_public_path__ + "img/bookingcom_icon.61f6827a.svg";